/**
 * Configuración de la aplicación
 */

interface Config {
    backendUrl: string;
}

const config: Config = {
    backendUrl: process.env.REACT_APP_BACKEND_URL || "/api",
};

export default config;
